import { checkStudentAdvisorSchoolMatch } from '../api/eae'

export function confirmAdvisorSchoolMatch(vm) {
    const form = vm.form || {}
    if (!form.adviser_email) {
        return Promise.resolve(true)
    }

    const accountId = form.account_id && form.account_id !== form.account_nameEN
        ? form.account_id
        : ''

    return checkStudentAdvisorSchoolMatch({
        adviser_email: form.adviser_email,
        account_id: accountId,
        account_nameEN: form.account_nameEN || '',
    }).then((res) => {
        const result = res.data && res.data.data ? res.data.data : {}
        if (!result.need_confirm) {
            return true
        }

        const studentSchool = result.student_school && result.student_school.name
            ? result.student_school.name
            : (form.account_nameEN || 'your selected school')
        const advisorSchool = result.advisor_school && result.advisor_school.name
            ? result.advisor_school.name
            : 'another school'

        return vm.$confirm(
            `The advisor email you entered is already associated with "${advisorSchool}" in our system, but your selected school is "${studentSchool}". Please confirm this advisor is from your school before continuing.`,
            'Advisor School Confirmation',
            {
                confirmButtonText: 'Confirm and Continue',
                cancelButtonText: 'Go Back and Edit',
                type: 'warning'
            }
        ).then(() => true).catch(() => false)
    }).catch(() => {
        vm.$message.error('Unable to verify advisor school. Please try again.')
        return false
    })
}
